/**
 * 共建店导入 2020-02-20
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool } from '@/tool'
import { ExportExcel } from '../../../../components/index'
import { modelUtils } from '../../../../utils'
let { WizTypography, WizSpin, WizModal} = component_tool;
let { WizContainer } = framework_tool;
const { Paragraph } = WizTypography;

class DealerUnionFileImport extends WizContainer {

  componentName = 'dealerUnionFileImport';

  _handldImport(nextProps, nextState) {
    let o = nextProps['dealerUnion']
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      WizModal.success({
        title:'导入结果',
        content:<p style={{whiteSpace: "pre-line"}}>{str}</p>
      })
      return true;
    } else {
      wizNotice.error("导入数据出错，请联系相关人员")
      return false;
    }
  }

  propsAndStateOnChange = {
    dealerUnion: this._handldImport.bind(this),
  }


  _render() {
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '共建店导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: constants.files.excel_demo,
      }

    }
    let submit = (file, fileData) => {
      let apiPath = 'dealerUnion/import';
      this.doAction({
        path: apiPath,
        payload: {
          key: "import",
          apiParams: {
            fileData
          }
        }
      });
    }
    let { dealerUnionLoading } = this.props;
    return (
      <WizSpin tip={'文件上传中'} spinning={dealerUnionLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
        />
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { dealerUnion } = state;
  const dealerImport = modelUtils.getModelEntity(dealerUnion, 'import');
  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'dealerUnion')
  return {
    dealerUnion: dealerImport,
    ...load
  }
};

export default connect(mapStateToProps)(DealerUnionFileImport);
